import React, { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { communitySearchInitializeEvent } from "store/actions/communities";
import { usePreferences, useRegionId } from "store/selectors/hooks";
import { useRegionSettings } from "store/selectors/settings";
import { Content, ContentContainer, PageHeader, Stage } from "../layout";
import { AddNewCommunityButton } from "./add-new-community-button";
import { CommunitySearchResults } from "./community-search-results";
import { SearchCommunity } from "./search-bar/search-bar";

export const CommunitySearch = () => {
    const dispatch = useDispatch();
    const preferences = usePreferences();
    const {
        settings: {
            defaultState,
            showCommunityBaseAndHighPrice,
            communityCardContactMode,
        },
    } = useRegionSettings();
    const defaultCommunitySortOrder = preferences.defaultCommunitySortOrder;
    const regionId = useRegionId("community");
    const searchKey = useMemo(() => `dashboard-${regionId}`, [regionId]);
    useEffect(() => {
        dispatch(
            communitySearchInitializeEvent(
                searchKey,
                defaultCommunitySortOrder,
                regionId,
            ),
        );
    }, [searchKey, regionId, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Stage>
            <PageHeader title="Communities">
                <AddNewCommunityButton />
            </PageHeader>
            <Content>
                <SearchCommunity
                    includedExcludedEnabled={false}
                    searchKey={searchKey}
                    defaultState={defaultState}
                    showCommunityBaseAndHighPrice={showCommunityBaseAndHighPrice}
                />
            </Content>
            <ContentContainer className="mt-2 lg:mt-4 mx-0! p-4 bg-zinc-50">
                <CommunitySearchResults
                    searchKey={searchKey}
                    communityCardContactMode={communityCardContactMode}
                />
            </ContentContainer>
        </Stage>
    );
};
